(function () {
  function setupReadings(section) {
    if (!section || section.dataset.readingsInitialized === 'true') return;

    section.dataset.readingsInitialized = 'true';

    var moreButton = section.querySelector('[data-reading-more]');
    var increment = parseInt(section.getAttribute('data-increment'), 10) || 3;

    if (moreButton) {
      moreButton.addEventListener('click', function () {
        var hiddenItems = Array.prototype.slice.call(
          section.querySelectorAll('[data-reading-item][hidden]')
        );

        hiddenItems.slice(0, increment).forEach(function (item) {
          item.hidden = false;
        });

        if (!section.querySelector('[data-reading-item][hidden]')) {
          moreButton.hidden = true;
        }
      });
    }

    var expandButton = section.querySelector('[data-reading-expand]');
    if (expandButton) {
      expandButton.addEventListener('click', function () {
        var collapsedText = section.querySelector('[data-reading-collapsed]');
        var expandedText = section.querySelector('[data-reading-expanded]');
        var articleLink = section.querySelector('[data-reading-article-link]');

        if (collapsedText) collapsedText.hidden = true;
        if (expandedText) expandedText.hidden = false;
        if (articleLink) articleLink.hidden = false;

        expandButton.setAttribute('aria-expanded', 'true');
        expandButton.hidden = true;
      });
    }
  }

  function setupAllReadings(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll('[data-jiyucho-readings]')
      : [];

    Array.prototype.forEach.call(sections, setupReadings);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupAllReadings(document);
    });
  } else {
    setupAllReadings(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupAllReadings(event.target);

    if (event.target.matches && event.target.matches('[data-jiyucho-readings]')) {
      setupReadings(event.target);
    }
  });
})();
